// Pure language resolution. No React, no window — the caller passes the raw
// `location.search` string and whatever localStorage held, so this is fully
// testable and has one obvious precedence order.
//
// Deliberately NO navigator.language sniffing: it surprises Finnish users on
// English-locale machines and is undebuggable over the phone. Language is an
// explicit choice (switcher) or an explicit link (?lang=en).

export const SUPPORTED = ["fi", "en"];
export const DEFAULT_LANGUAGE = "fi";
export const STORAGE_KEY = "bj.lang";

function normalize(value) {
    const v = String(value || "").trim().toLowerCase();
    return SUPPORTED.includes(v) ? v : null;
}

/**
 * Precedence: ?lang= query param → stored preference → Finnish.
 * Unsupported values at either level are ignored, never trusted.
 *
 * @param {{search?: string, stored?: string|null}} [params]
 * @returns {"fi"|"en"}
 */
export function resolveLanguage({ search = "", stored = null } = {}) {
    const fromQuery = normalize(new URLSearchParams(search).get("lang"));
    if (fromQuery) return fromQuery;
    return normalize(stored) || DEFAULT_LANGUAGE;
}
